import UsersScreenConnector from './UsersScreenConnector';

export default UsersScreenConnector;
